import { gql } from '@apollo/client'

export const Query = gql`
  query Clients($companyId: ID!, $filters: ClientFilters, $order: ClientOrder, $after: String, $before: String, $first: Int, $last: Int) {
    clients(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        organisationName
        clientType { id name color }
        eventsCount
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
